import axios from "../BASE_API";
import AuthHeader from "../AuthHeader";

export class DashboardAPI {
    
    getDashboardSummary: any = () => {
        return axios.get('/dashboard/summary', { headers: AuthHeader() });
    };

    getMonthWiseOrder: any = () => {
        return axios.get('/dashboard/month-wise-order', { headers: AuthHeader() });
    };

}



